import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import importCsvIcon from '../assets/images/payslip/import-csv.png';
import payslipIcon from '../assets/images/payslip/payslip.png';
import sendIcon from '../assets/images/payslip/send.png';
import payrollImage from '../assets/images/payslip/right.png';
import { hasModulePermission } from '../utils/permissions';

const PaySlip = () => {
  const navigate = useNavigate();
  
  const steps = [
    hasModulePermission('payslip.import', 'create') && { icon: importCsvIcon, title: 'Import CSV', path: '/payslip/import' },
    hasModulePermission('payslip.list', 'view') && { icon: payslipIcon, title: 'Pay Slip List', path: '/payslip/list' },
    hasModulePermission('payslip.send', 'create') && { icon: sendIcon, title: 'Send to Employee', path: '/payslip/send' }
  ].filter(Boolean);

  return (
    <DashboardLayout>
      <div className="container py-5 position-relative" style={{ minHeight: '80vh' }}>
        <div className="row mb-5">
          <div className="col-12">
            <div className="d-flex justify-content-center gap-4">
              {steps.length === 0 ? (
                <div className="text-muted">No payslip modules assigned to your role.</div>
              ) : steps.map((step) => (
                <div 
                  key={step.title}
                  className="card cursor-pointer shadow-sm" 
                  style={{ 
                    width: '250px',
                    borderRadius: '15px',
                    transition: 'transform 0.2s'
                  }}
                  onClick={() => navigate(step.path)}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                  <div className="card-body text-center p-4">
                    <div className="mb-3">
                      <img
                        src={step.icon}
                        alt={step.title}
                        className="img-fluid"
                        style={{ height: '100px', objectFit: 'contain' }}
                      />
                    </div>
                    <h6 className="mb-0">{step.title}</h6>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div 
          style={{ 
            position: 'absolute',
            bottom: '0',
            right: '0',
            width: '50%',
            maxWidth: '600px'
          }}
        >
          <img
            src={payrollImage}
            alt="Payroll"
            className="img-fluid"
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PaySlip;